<script setup lang="ts">
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { Avatar, AvatarImage } from '@/components/ui/avatar'

const props = defineProps<{
    text?: string
}>()
</script>

<template>
    <div class="flex items-center justify-center w-full h-screen">
        <div>
            <div class="text-center">
                <Avatar class="w-[165px] bg-transparent">
                    <AvatarImage src="/svg/amphora-logo.svg" />
                </Avatar>
            </div>
            <div class="flex items-center justify-center space-x-2">
                <FontAwesomeIcon icon="fas fa-loader" class="animate-spin" />
                <p class="text-sm">{{ props.text ?? 'Loading...' }}</p>
            </div>
        </div>
    </div>
</template>

<style scoped></style>
